import { createGetAllApi } from "@api/util/createGetAllApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";
import type { IResponseOption } from "@interfaces";

import type { IPathBaseParam } from "./path";
import type { ITransactionKindsEnum } from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IResponseOption<ITransactionKindsEnum>>>,
  IPathBaseParam,
  IPaginationParams
>("selectTypes.transactionKinds");

export const transactionKinds = {
  ...getAllApis,
};
